import { render, staticRenderFns } from "./CollisionEditPage.vue?vue&type=template&id=53f65bf6&scoped=true"
import script from "./CollisionEditPage.vue?vue&type=script&lang=js"
export * from "./CollisionEditPage.vue?vue&type=script&lang=js"
import style0 from "./CollisionEditPage.vue?vue&type=style&index=0&id=53f65bf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f65bf6",
  null
  
)

export default component.exports